import React from "react";

const Bash_Scp = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Scp</h2>
      <p>Secure copy over SSH.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>scp [options] source dest</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>scp file.txt user@host:/path/
scp -r dir/ user@host:/path/</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -P to specify a non-default port.</p>
    </div>
  );
};

export default Bash_Scp;
